module.exports = __webpack_public_path__ + "assets/img/activity-time-a6ccf04a.png";